
import { Product } from "@/types/product";
import { touchPanelProducts } from "./reax/touch-panels";
import { controlProcessorProducts } from "./reax/control-processors";
import { softwareAndAccessoryProducts } from "./reax/software-accessories";

export const reaxProducts: Product[] = [
  ...touchPanelProducts,
  ...controlProcessorProducts,
  ...softwareAndAccessoryProducts
];
